<template>
  <el-card class="box-card">
    <el-form class="global-form1" label-position="right" label-width="110px">
      <p class="title bold">机械基础信息</p>
      <el-form-item label="机械名称" prop="machineryName">
        {{ formData.machineryName }}
      </el-form-item>
      <el-form-item label="规格/型号" prop="specificationModel">
        {{ formData.specificationModel }}
      </el-form-item>
      <el-form-item label="单价" prop="unitPrice">
        {{ formData.unitPrice }}
      </el-form-item>
      <el-form-item label="所属供应商" prop="supplierName">
        {{ formData.supplierName }}
      </el-form-item>
      <el-form-item label="是否含油" prop="whetherOil">
        {{ formData.whetherOil === '1' ? '是' : '否' }}
      </el-form-item>
    </el-form>
    <el-form class="global-form2" label-position="right" label-width="110px">
      <p class="title bold">资质证书</p>
      <el-form-item prop="driveFileList" label="驾驶许可证">
        <custom-upload v-model="formData.driveFileList" disabled></custom-upload>
      </el-form-item>
      <el-form-item prop="envirFileList" label="环保证书">
        <custom-upload v-model="formData.envirFileList" disabled></custom-upload>
      </el-form-item>
      <el-form-item prop="otherFileList">
        <template slot="label">其他材料<br>(最多6张)</template>
        <custom-upload v-model="formData.otherFileList" disabled></custom-upload>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>

export default {
  data () {
    return {
      formData: {
        machineryName: '', // 机械名称
        specificationModel: '', // 规格/型号
        supplierId: '', // 所属供应商
        projectName: '', // 所属项目
        pricingMethod: '', // 计价方式
        unitPrice: '', // 含税单价
        whetherOil: '2', // 是否含油
        driverName: '', // 驾驶员姓名
        identityCard: '', // 驾驶证号
        mobileNumber: '', // 手机号
        engineNumber: '', // 发动机编号
        remarks: '' // 备注
      }
    }
  },
  computed: {
    machineryId () {
      return this.$route.query.machineryId
    }

  },

  created () {
    this.loadData()
  },
  methods: {

    loadData () {
      this.$axios.get(this.$apis.material.selectYhMachineryByMachineryId, {
        machineryId: this.machineryId
      }).then(res => {
        this.formData = res
      })
    }

  }
}
</script>

<style scoped lang="scss">
.title {
  font-size: 14px;
  margin-bottom: 20px;
  font-weight: bold;
}

.global-form2 {
  border-top: 1px solid #ccc;
  padding-top: 14px;
}
</style>
